<template>
  <div class="mt-4">
    <v-card class="mx-auto" max-width="900" elevation="2">
      <v-toolbar dark>
        <v-toolbar-title>프롬북 · 공지 {{ isEdit ? '수정' : '작성' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip small outlined dark v-if="isEdit" class="mr-2">ID: {{ form.id }}</v-chip>
      </v-toolbar>

      <v-card-text class="pa-6">
        <v-text-field
          v-model="form.title"
          label="제목"
          outlined
          dense
          class="mb-4"
        ></v-text-field>

        <v-row>
          <v-col cols="12" sm="6">
            <v-select
              v-model="form.notice_type"
              label="공지 타입"
              :items="[{text: '일반', value: 'normal'}, {text: '숨김', value: 'hidden'}]"
              item-text="text"
              item-value="value"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-switch v-model="form.is_enabled" label="활성화" inset color="green"></v-switch>
          </v-col>
        </v-row>

        <!-- 본문 에디터 (TinyMCE) -->
        <tiny-editor v-model="form.message" upload-prefix="project_prombook/notice/images/" />
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-btn color="primary" depressed @click="save" :loading="saving">
          <v-icon left>mdi-content-save</v-icon>저장
        </v-btn>
        <v-btn text @click="goList">
          <v-icon left>mdi-arrow-left</v-icon>목록으로
        </v-btn>
      </v-card-actions>
    </v-card>

    <div class="py-12"></div>
  </div>
</template>

<script>
import TinyEditor from '../common/TinyEditor.vue';
import { prombook } from '../../api';

export default {
  name: 'Prombook_NoticeWrite',
  components: { TinyEditor },
  data() {
    return {
      saving: false,
      form: {
        id: null,
        title: '',
        message: '',
        notice_type: 'normal',
        is_enabled: true,
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id;
    },
  },
  mounted() {
    if (this.isEdit) {
      this.form.id = this.$route.params.id;
      this.loadNotice(this.$route.params.id);
    }
  },
  methods: {
    async loadNotice(id) {
      try {
        const r = await prombook.get_notice(id);
        if (r && r.notice_info) {
          const n = r.notice_info;
          this.form = {
            id: n.id,
            title: n.title || '',
            message: n.message || '',
            notice_type: n.notice_type || 'normal',
            is_enabled: n.is_enabled !== undefined ? n.is_enabled : true,
          };
        }
      } catch (e) {
        console.error(e);
        alert('공지 로드에 실패했습니다.');
      }
    },
    async save() {
      if (!this.form.title.trim()) {
        alert('제목을 입력해주세요.');
        return;
      }
      const message = this.form.message || '';
      try {
        this.saving = true;
        await prombook.save_notice({
          id: this.form.id || undefined,
          title: this.form.title,
          message,
          notice_type: this.form.notice_type,
          is_enabled: this.form.is_enabled,
          admin_user: localStorage.user_id || 'cms',
        });
        alert('저장되었습니다.');
        this.goList();
      } catch (e) {
        console.error(e);
        alert('저장에 실패했습니다.');
      } finally {
        this.saving = false;
      }
    },
    goList() {
      this.$router.push('/prombook/notice/list');
    },
  },
};
</script>
